<template>
  <svg
    version="1.1"
    id="Ebene_1"
    x="0px"
    y="0px"
    viewBox="0 0 1000 1000"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    style="enable-background: new 0 0 1000 1000"
  >
    <defs>
      <pattern
        id="color"
        patternUnits="userSpaceOnUse"
        width="1000"
        height="1000"
      >
        <image
          xlink:href="/img/markencode/markencode-farbkreis.jpg"
          x="-20"
          y="-20"
          width="1040"
          height="1040"
        />
      </pattern>
    </defs>
    <g class="matrix">
      <!-- quarter overlay with point in the middle -->
      <svg-4x-matrix></svg-4x-matrix>
    </g>

    <!-- only admin: start -->
    <svg-comfort-zones :active-zones="activeZones"></svg-comfort-zones>
    <!-- only admin: end -->

    <svg-value-zones :active-area="activeArea"></svg-value-zones>

    <g class="positions">
      <svg-circles :selected-words="activeArea ? selectedWords : []"></svg-circles>

      <!-- outlines are currently not used -->
      <svg-outlines></svg-outlines>

      <svg-texts :selected-words="activeArea ? selectedWords : []"></svg-texts>
    </g>

    <!-- only admin: start -->
    <svg-strokes></svg-strokes>
    <!-- only admin: end -->

    <!-- <svg-markencode-m :validity="validity"></svg-markencode-m> -->
  </svg>
</template>

<script>
import SvgMarkencodeM from '@/Pages/Markencode/Dictionary/Shared/SvgMarkencodeM.vue';
import Svg4xMatrix from '@/Pages/Markencode/Dictionary/Shared/Svg4xMatrix.vue';
import SvgValueZones from '@/Pages/Markencode/Dictionary/Shared/SvgValueZones.vue';
import SvgComfortZones from '@/Pages/Markencode/Dictionary/Shared/SvgComfortZones.vue';
import SvgStrokes from '@/Pages/Markencode/Dictionary/Shared/SvgStrokes.vue';
import SvgCircles from '@/Pages/Markencode/Dictionary/Shared/SvgCircles.vue';
import SvgOutlines from '@/Pages/Markencode/Dictionary/Shared/SvgOutlines.vue';
import SvgTexts from '@/Pages/Markencode/Dictionary/Shared/SvgTexts.vue';

export default {
  components: {
    SvgMarkencodeM,
    Svg4xMatrix,
    SvgValueZones,
    SvgComfortZones,
    SvgStrokes,
    SvgCircles,
    SvgOutlines,
    SvgTexts,
  },

  props: {
    activeZones: {
      type: Object,
      required: false,
      default: () => {},
    },
    validity: {
      type: Boolean,
      required: false,
      default: null,
    },
    activeArea: {
      type: String,
      required: false,
      default: '',
    },
    selectedWords: {
      type: Array,
      required: false,
      default: [],
    },
  },
};
</script>